import { render, staticRenderFns } from "./ViewTitlePagePeople.vue?vue&type=template&id=2abfae5b"
import script from "./ViewTitlePagePeople.vue?vue&type=script&lang=js"
export * from "./ViewTitlePagePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports